<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 7L5.71932 13.209C5.32339 13.6004 5.32336 14.2398 5.71927 14.6312L6.40051 15.3048C6.79013 15.69 7.41718 15.69 7.80675 15.3047L12 11.1579L16.1932 15.3047C16.5828 15.69 17.2099 15.69 17.5995 15.3048L18.2807 14.6312C18.6766 14.2398 18.6766 13.6004 18.2807 13.209L12 7Z"
      class="fill-current"
    />
  </svg>
</template>
